import { PageHero } from "../components/site/PageHero";
import { FadeUp, Eyebrow } from "../components/site/Motion";
import { CtaBand } from "../components/site/CtaBand";
import { IMG } from "../data/content";
import { useLang } from "../i18n/LangContext";

export default function ChiSiamo() {
  const { t } = useLang();
  const c = t.chi;
  return (
    <main data-testid="chi-siamo-page">
      <PageHero
        testId="chi-siamo-hero"
        key={c.lines[0]}
        eyebrow={c.eyebrow}
        lines={c.lines}
        intro={c.intro}
        img={IMG.viaggio}
      />

      <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8 lg:pb-32">
        <div className="grid gap-10 border-t border-[#D6CEBF] pt-14 lg:grid-cols-12">
          <FadeUp className="lg:col-span-4"><Eyebrow>{c.missionEyebrow}</Eyebrow></FadeUp>
          <FadeUp delay={0.1} className="space-y-6 text-base leading-relaxed text-stone-600 sm:text-lg lg:col-span-7">
            <p className="font-serif text-3xl leading-snug text-[#1C1917] sm:text-4xl">
              {c.mission}
            </p>
            <p>
              {c.missionText}
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="bg-[#F3EFE6] py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <FadeUp>
            <Eyebrow>{c.valuesEyebrow}</Eyebrow>
            <h2 className="max-w-2xl font-serif text-4xl tracking-tight text-[#1C1917] sm:text-6xl">{c.valuesTitle}</h2>
          </FadeUp>
          <div className="mt-16 grid gap-px overflow-hidden border border-[#D6CEBF] bg-[#D6CEBF] sm:grid-cols-2">
            {c.values.map((v, i) => (
              <FadeUp key={v.k} delay={i * 0.08} className="group bg-[#F3EFE6] p-8 transition-colors duration-500 hover:bg-[#FBF9F5] sm:p-10" data-testid={`valore-${i}`}>
                <span className="font-mono text-xs text-[#C85A32]">0{i + 1}</span>
                <h3 className="mt-6 font-serif text-3xl text-[#1C1917]">{v.k}</h3>
                <p className="mt-3 max-w-sm text-stone-600">{v.v}</p>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <CtaBand title={c.cta.title} to="/cosa-facciamo" label={c.cta.label} testId="chi-siamo-cta" />
    </main>
  );
}
